import React, { useState, useEffect } from 'react';
import { FiX, FiChevronRight, FiFolder } from 'react-icons/fi';
import { getParcelFolders, getParcelProjects, previewParcelData, importParcelsToJob } from '../services/api';

// Multi-step parcel import browser: County folder -> Project -> preview -> import.
export default function ParcelImportModal({ jobId, onClose, onImported }) {
  const [folders, setFolders] = useState([]);
  const [projects, setProjects] = useState([]);
  const [preview, setPreview] = useState([]);
  const [county, setCounty] = useState(null);
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [importing, setImporting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      try { const r = await getParcelFolders(); setFolders(r.data.folders || []); }
      catch (e) { setError('Could not load county folders'); }
      setLoading(false);
    })();
  }, []);

  const pickCounty = async (c) => {
    setCounty(c); setProject(null); setPreview([]); setLoading(true); setError('');
    try { const r = await getParcelProjects(c.path); setProjects(r.data.projects || []); }
    catch (e) { setError('Could not load projects'); }
    setLoading(false);
  };
  const pickProject = async (p) => {
    setProject(p); setLoading(true); setError('');
    try { const r = await previewParcelData(p.path); setPreview(r.data.parcels || []); }
    catch (e) { setError('Could not preview parcels'); }
    setLoading(false);
  };
  const doImport = async () => {
    if (!project) return;
    setImporting(true); setError('');
    try {
      const r = await importParcelsToJob(jobId, project.path);
      onImported(r.data.imported_count || 0);
      onClose();
    } catch (e) {
      setError('Import failed: ' + (e?.response?.data?.error || e.message));
      setImporting(false);
    }
  };

  return (
    <div className="qv-modal-overlay" onClick={onClose}>
      <div className="qv-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 760 }}>
        <div className="qv-modal-head">
          <h3>Import Parcels from County Records</h3>
          <button className="btn-ghost" onClick={onClose}><FiX /> Close</button>
        </div>

        <div style={{ padding: '0.6rem 1.5rem', fontSize: '0.82rem', color: '#6b7280', display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'wrap' }}>
          <span style={{ cursor: 'pointer', color: county ? '#2563eb' : 'inherit' }}
            onClick={() => { setCounty(null); setProject(null); setPreview([]); }}>Counties</span>
          {county && <><FiChevronRight size={11} /><span style={{ cursor: 'pointer', color: project ? '#2563eb' : 'inherit' }}
            onClick={() => { setProject(null); setPreview([]); }}>{county.name}</span></>}
          {project && <><FiChevronRight size={11} />{project.name}</>}
        </div>

        <div className="qv-modal-body" style={{ display: 'block' }}>
          {error && <div style={{ color: '#dc2626', marginBottom: 8 }}>{error}</div>}
          {loading ? (
            <div className="dash-mini-empty">Loading…</div>
          ) : !county ? (
            folders.length ? (
              <div className="qv-pi-list">
                {folders.map(f => (
                  <button key={f.path} className="qv-pi-item" onClick={() => pickCounty(f)}>
                    <FiFolder size={14} /> {f.name} <FiChevronRight size={14} style={{ marginLeft: 'auto' }} />
                  </button>
                ))}
              </div>
            ) : <div className="dash-mini-empty">No county folders found on the server.</div>
          ) : !project ? (
            projects.length ? (
              <div className="qv-pi-list">
                {projects.map(p => (
                  <button key={p.path} className="qv-pi-item" onClick={() => pickProject(p)}>
                    <FiFolder size={14} /> {p.name} <FiChevronRight size={14} style={{ marginLeft: 'auto' }} />
                  </button>
                ))}
              </div>
            ) : <div className="dash-mini-empty">No projects in this county.</div>
          ) : (
            <div>
              <div style={{ fontSize: '0.85rem', marginBottom: 8 }}><strong>{preview.length}</strong> parcel(s) found in {project.name}:</div>
              {preview.length > 0 && (
                <table className="dash-prof-table">
                  <thead><tr><th>Parcel ID</th><th>Owner</th><th>Address</th><th style={{ textAlign: 'right' }}>Acres</th></tr></thead>
                  <tbody>
                    {preview.map((p, i) => (
                      <tr key={i}><td>{p.parcel_id}</td><td>{p.owner}</td><td>{p.property_address}</td><td style={{ textAlign: 'right' }}>{p.acres}</td></tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          )}
        </div>

        <div className="qv-modal-foot">
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
          {project && (
            <button className="btn btn-primary" onClick={doImport} disabled={importing}>
              {importing ? 'Importing…' : `Import ${preview.length} Parcel(s)`}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
